import { Model } from "@/models/base/model";

export class NoticeList extends Model {
  constructor(params: any = {}) {
    super(params);
    this.name = "NoticeList";
  }

  // お知らせ一覧取得
  async getTotalCount(): Promise<any> {
    this.url = `/cms/api/notice-cnt`;
    return await super.fetch();
  }
  async getPageData(page: number, size: number): Promise<any> {
    this.url = `/cms/api/notice-data?page=${page}&size=${size}`;
    return await super.fetch();
  }
  async readNotice(articleId: number): Promise<any> {
    this.url = `/cms/api/notice-read?article_id=${articleId}`;
    return super.save({}, "POST");
  }
}
